export enum CareCoordinationSubWidget {
  Sdoh = 'SDoH',
  Stars = 'STARs',
  Wcc = 'wound-management',
  CaseManagement = 'case-management',
  Referral = 'referral'
}

export enum CareCoordinationSubWidgetTab {
  Sdoh,
  Stars,
  Wcc,
  CaseManagement,
  Referral
}
